<template>
  <section class="projects" id="projects">
    <div class="container">
      <div class="plaque-title"><h2>Research Papers</h2></div>
      <div class="papers-grid">
        <div v-for="(paper, index) in papers" :key="index" class="paper-card">
          <h3>{{ paper.title }}</h3>
          <p class="authors">{{ paper.authors }}</p>
          <p v-if="paper.publication" class="publication">{{ paper.publication }}</p>
          <div class="links">
            <a v-if="paper.pdf" :href="paper.pdf" class="btn" target="_blank" rel="noopener noreferrer">
              <span>PDF</span>
            </a>
            <a v-if="paper.ssrn" :href="paper.ssrn" class="btn" target="_blank" rel="noopener noreferrer">
              <span>SSRN</span>
            </a>
            <a v-if="paper.slides" :href="paper.slides" class="btn" target="_blank" rel="noopener noreferrer">
              <span>Slides</span>
            </a>
            <a v-if="paper.website" :href="paper.website" class="btn" target="_blank" rel="noopener noreferrer">
              <span>Website</span>
            </a>
            <a v-if="paper.visualizations" :href="paper.visualizations" class="btn" target="_blank" rel="noopener noreferrer">
              <span>Visualizations</span>
            </a>
            <a v-if="paper.github" :href="paper.github" class="btn" target="_blank" rel="noopener noreferrer">
              <span>GitHub</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ProjectsSection',
  data() {
    return {
      papers: [
        {
          title: 'Demographics and Technology Adoption',
          authors: 'Zeshu Xu',
          pdf: 'https://zeshuxu.weebly.com/uploads/1/5/3/1/153161884/demographics_and_technology_adoption.pdf',
          ssrn: 'https://papers.ssrn.com/sol3/papers.cfm?abstract_id=5702822'
        },
        {
          title: 'Asset Prices and Portfolio Choice with Learning from Experience',
          authors: 'P. Ehling, A. Graniero, C. Heyerdahl-Larsen',
          publication: 'Review of Economic Studies, 2018, 85 (3), 1752-1780',
          pdf: 'https://biopen.bi.no/bi-xmlui/bitstream/handle/11250/2558066/Asset%20prices%20and%20portfolio%20choice%202018.pdf?sequence=4&isAllowed=y',
          ssrn: 'https://papers.ssrn.com/sol3/papers.cfm?abstract_id=2378330',
          visualizations: 'https://financebi.shinyapps.io/learning_from_experience/',
          github: 'https://github.com/OLG-Finance/AssetPricingWithLearningFromExperience'
        },
        {
          title: 'Demand Disagreement',
          authors: 'Christian Heyerdahl-Larsen, Philipp K. Illeditsch',
          publication: 'Journal of Financial Economics, Forthcoming',
          ssrn: 'https://papers.ssrn.com/sol3/papers.cfm?abstract_id=3092366'
        },
        {
          title: 'The Debt Capacity of a Government',
          authors: 'Bernard Dumas, Paul Ehling, Chunyu Yang',
          publication: 'Management Science, Forthcoming',
          ssrn: 'https://papers.ssrn.com/sol3/papers.cfm?abstract_id=3953960'
        },
        {
          title: 'Buy High, Cry Later: Beliefs-driven Cycles of Stock Market Participation',
          authors: 'Paul Ehling, Christian Heyerdahl-Larsen, Zeshu Xu',
          publication: 'Working Paper, 2025',
          visualizations: 'https://financebi.shinyapps.io/buyhigh_crylater/',
          ssrn: 'https://papers.ssrn.com/sol3/papers.cfm?abstract_id=4283101'
        },
        {
          title: 'Asset Prices with Wealth Dispersion',
          authors: 'Paul Ehling,Christian Heyerdahl-Larsen, Junjie Guo',
          publication: 'Working Paper, 2024',
          ssrn: 'https://papers.ssrn.com/sol3/papers.cfm?abstract_id=3797399'
        }
      ]
    }
  }
}
</script>

<style scoped>
.projects {
  padding: 4rem 0;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

.plaque-title {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 3rem;
}

.plaque-title h2 {
  background: rgba(255,255,255,0.85);
  box-shadow: 0 2px 12px rgba(0,0,0,0.08);
  border-radius: 16px;
  padding: 1rem 2.5rem;
  font-size: 2.5rem;
  color: #1a1a1a;
  backdrop-filter: blur(6px);
  margin: 0;
}

.papers-grid {
  display: grid;
  gap: 2rem;
  grid-template-columns: 1fr;
}

.paper-card {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 2rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.paper-card:hover {
  transform: translateY(-5px);
}

h3 {
  font-size: 1.5rem;
  color: #1a1a1a;
  margin-bottom: 1rem;
}

.authors {
  color: #666;
  margin-bottom: 1.5rem;
  font-size: 1.1rem;
}

.publication {
  color: #777;
  margin-bottom: 1.5rem;
  font-size: 1rem;
  font-style: italic;
}

.links {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

.btn {
  display: inline-flex;
  align-items: center;
  padding: 0.5rem 1.5rem;
  background-color: #2c3e50;
  color: white;
  text-decoration: none;
  border-radius: 4px;
  font-weight: 500;
  transition: background-color 0.3s ease;
}

.btn:hover {
  background-color: #1a252f;
}

@media (max-width: 768px) {
  .papers-grid {
    gap: 1.5rem;
  }
  
  .paper-card {
    padding: 1.5rem;
  }
}
</style>
